// store/modules/orders.js
import { collection, getDocs, getFirestore } from "firebase/firestore";
import 'firebase/firestore'


const state = {
  order: null
}

const getters = {
  getOrder: state => state.order
}

const mutations = {
  setOrder(state, order) {
    state.order = order
  }
}

const actions = {
  // fetchOrder({ commit }, orderId) {
  //   // Assuming you have already initialized Firebase in your project
  //   const orderRef = firebase.firestore().collection('orders').doc(orderId)

  //   orderRef.get().then(doc => {
  //     if (doc.exists) {
  //       const order = doc.data()
  //       commit('setOrder', order)
  //     } else {
  //       // Handle case when order does not exist
  //     }
  //   }).catch(error => {
  //     // Handle error
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
